import { createContext, useContext } from 'react';

export const DocumentsContext = createContext(undefined);

export const useDocumentsContext = () => {
  const cxt = useContext(DocumentsContext);

  if (!cxt) throw new Error('useDocumentsContext must be used with provider');

  return cxt;
};
